import axios from 'axios';
import { createStore } from 'vuex';

const initialState = () => {
  return {
    user_id:localStorage.getItem('user_id') || null,
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true' || false,
    isTokenExpired: localStorage.getItem('isTokenExpired') === 'true' || false,
    accessToken: localStorage.getItem('accessToken') || null,
    tokenExpiry: localStorage.getItem('tokenExpiry') || null,
    channelData: null,
    email:null,
    token:null,
    previewData: localStorage.getItem('previewData') || null,
    guideline:localStorage.getItem('guideline') || null,
    // #301: CS審査ステータス (camelCase 統一)
    applicationStatus: (() => {
      // null/空文字を除外。空文字は Number("")=0 になり未申請扱いで誤リダイレクトするため
      const raw = localStorage.getItem('applicationStatus');
      if (raw === null || raw === '') return null;
      const num = Number(raw);
      return Number.isNaN(num) ? null : num;
    })(),
    waitForInvitation: localStorage.getItem('waitForInvitation') === 'true',
    showApprovalAlert: localStorage.getItem('showApprovalAlert') === 'true',
    applicationEmail: localStorage.getItem('applicationEmail') || null,
    hasMembership: localStorage.getItem('hasMembership') === 'true',
  };
};

export default createStore({
  state: initialState(),
  mutations: {
    setUserID(state, user_id) {
      state.user_id = user_id;
      localStorage.setItem('user_id', user_id);
    },
    setChannelData(state, channelData) {
      state.channelData = channelData;
    },
    setemail(state, email){
      state.email = email;
    },
    settoken(state, token){
      state.token = token;
    },
    setPreviewData(state, previewData){
      state.previewData = previewData;
      localStorage.setItem('previewData', previewData);
    },
    setAuthentication(state, status) {
      state.isAuthenticated = status;
      localStorage.setItem('isAuthenticated', status);
    },
    setTokenExpired(state, status) {
      state.isTokenExpired = status;
      localStorage.setItem('isTokenExpired', status);
    },
    setAccessToken(state, token) {
      state.accessToken = token;
      localStorage.setItem('accessToken', token);
    },
    setTokenExpiry(state, expiry) {
      state.tokenExpiry = expiry;
      localStorage.setItem('tokenExpiry', expiry);
    },
    setGuidelineConsent(state, guideline) {
      state.guideline = guideline;
      localStorage.setItem('guideline', guideline);
    },
    // #301: 審査ステータス関連 mutation
    setApplicationStatus(state, value) {
      state.applicationStatus = value;
      if (value === null || value === undefined) {
        localStorage.removeItem('applicationStatus');
      } else {
        localStorage.setItem('applicationStatus', String(value));
      }
    },
    setWaitForInvitation(state, value) {
      state.waitForInvitation = !!value;
      localStorage.setItem('waitForInvitation', String(!!value));
    },
    setShowApprovalAlert(state, value) {
      state.showApprovalAlert = !!value;
      localStorage.setItem('showApprovalAlert', String(!!value));
    },
    setHasMembership(state, value) {
      state.hasMembership = !!value;
      localStorage.setItem('hasMembership', String(!!value));
    },
    setApplicationEmail(state, value) {
      state.applicationEmail = value || null;
      if (value) {
        localStorage.setItem('applicationEmail', value);
      } else {
        localStorage.removeItem('applicationEmail');
      }
    },
    clear_register_data(state) {
      state.channelData = null;
      state.email = null;
      state.token = null;
      state.previewData = null;
    },
    clear_application_data(state) {
      state.applicationStatus = null;
      // waitForInvitation はログアウト時にクリアしない。
      // 「招待を待つ」選択後にログアウト→再ログインしても waiting 画面に遷移させるため。
      // クリアは申請送信時 (ChannelApplicationForm) または招待承認時 (MemberInvitationModal) に行う。
      state.showApprovalAlert = false;
      state.applicationEmail = null;
      localStorage.removeItem('applicationStatus');
      localStorage.removeItem('showApprovalAlert');
      localStorage.removeItem('applicationEmail');
    },
  },
  actions: {
    async refreshToken({ state, commit }) {
      try {
        // トークンリフレッシュのAPIリクエスト
        console.log(state.user_id);
        const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
        //'http://127.0.0.1:8000/api/v1/refresh-token/'
        const response = await axios.post(`${apiEndpoint}/refresh-token/`, {
          user_id: state.user_id
    });
        // 新しいトークンと有効期限を保存
        commit('setAccessToken', response.data.access_token);
        commit('setTokenExpiry', response.data.expiry);
        commit('setTokenExpired', response.data.isTokenExpired);

        // 新しいアクセストークンを返す
        return response.data.access_token;
      } catch (error) {
        commit('setAuthentication', false);
        commit('setTokenExpired', true);
        commit('clear_register_data');
        throw error; // エラーを再スローしてインターセプタでキャッチ可能にする
      }
    },

    login({ commit }, { user_id, accessToken, expiry, guideline, applicationStatus, waitForInvitation, showApprovalAlert, hasMembership }) {
      commit('setAuthentication', true);
      commit('setTokenExpired', false);
      commit('setUserID', user_id);
      commit('setAccessToken', accessToken);
      commit('setTokenExpiry', expiry);
      commit('setGuidelineConsent',guideline);
      // #301: 審査ステータスをレスポンスから取り込む (未指定時は既存値維持)
      if (applicationStatus !== undefined) {
        commit('setApplicationStatus', applicationStatus);
      }
      if (waitForInvitation !== undefined) {
        commit('setWaitForInvitation', waitForInvitation);
      }
      if (showApprovalAlert !== undefined) {
        commit('setShowApprovalAlert', showApprovalAlert);
      }
      if (hasMembership !== undefined) {
        commit('setHasMembership', hasMembership);
      }
    },
    async logout({ state, commit }) {
        try {
            // ログアウトAPIへのリクエスト
            const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
            await axios.post(`${apiEndpoint}/logout/`, {
              user_id: state.user_id
            });
            // Vuexの状態を更新
            commit('setUserID',null);
            commit('setAuthentication', false);
            commit('setTokenExpired', false);
            commit('setAccessToken', null);
            commit('setTokenExpiry', null);
            commit('setPreviewData', null);
            commit('setGuidelineConsent',null);
            commit('clear_application_data');

          } catch (error) {
            // エラーハンドリング
            commit('setAuthentication', false);
            commit('setTokenExpired', false);
            commit('setAccessToken', null);
            commit('setTokenExpiry', null);
            commit('setPreviewData', null);
            commit('setGuidelineConsent',null);
            commit('clear_application_data');
          }
    },
    clearregisterdata({ commit }) {
      commit('clear_register_data');
    },
  }
});
